import { Flex } from 'antd';
import { Text } from 'components/mvp-typography';
import { ErrorMessage } from 'features/sign-in/v2/ErrorMessage';
import { useCallback, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { paths } from 'routes';
import { useImpactPilotMutations } from '../_utils/use-impact-pilot-mutations';

interface PilotJoinFormProps {
  clinicianDisplayName: string;
}

// eslint-disable-next-line
export function PilotJoinForm(_props: PilotJoinFormProps) {
  const joinPilotMutation = useImpactPilotMutations();
  const history = useHistory();
  const location = useLocation();
  const handleJoinPilot = useCallback(
    () => {
      joinPilotMutation.joinPilot.mutate(void 0, {
        onSuccess() {
          history.push({
            pathname: paths.integration.impact.addPatient(),
            search: location.search
          });
        }
      });
    },

    // eslint-disable-next-line
    [joinPilotMutation.joinPilot.mutate, history, location]
  );

  useEffect(() => {
    handleJoinPilot();
  }, [handleJoinPilot]);

  return (
    <Flex
      vertical
      align="center"
      justify="center"
      gap={16}
      style={{ height: '100%' }}
    >
      <Text>Joining the Pilot...</Text>
      {/* <div>
        <Title>Join the Pilot</Title>
        <Text>Hello, {props.clinicianDisplayName}</Text>
        <Text>
          Please confirm that you would like to join the 2026 ImPACT Pilot.
        </Text>
        <Text>You will be automatically added to the Pilot Clinic.</Text>
      </div>
      <Flex gap={16}>
        <BaseButton
          onClick={handleJoinPilot}
          loading={joinPilotMutation.joinPilot.isPending}
          disabled={joinPilotMutation.joinPilot.isPending}
        >
          Join the Pilot
        </BaseButton>
        <Link to={Routes.ClinicianHome}>
          <BaseButton type="text">Not right now</BaseButton>
        </Link>
      </Flex> */}

      {joinPilotMutation.joinPilot.isError && (
        <ErrorMessage
          errorMessage={joinPilotMutation.joinPilot.error.message}
        />
      )}
    </Flex>
  );
}
